import { IsDefined, IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class SalutationApiModel {
  @IsString()
  @IsDefined()
  @MaxLength(50)
  @IsNotEmpty()
  name!: string;
}
